<template>
  <div class="cashflow-type-tracking-category card-box">
    <div class="card-wrapper" :class="{ 'showing-edit-menu': showSectionMenu }">
      <div class="header">
        <span class="title">{{ titles.cardTitle }}</span>
        <img class="edit" v-on:click.stop="openSectionMenu"
             :src="require('@/assets/icons/menu.svg')">
      </div>

      <expense-progress :recommended-or-expected-amount="subtree.recommendedOrExpectedAmount"
                        :recommended-or-expected-label="titles.expenseProgress.recommendedLabel"
                        :up-to-now-label="titles.expenseProgress.actualsLabel"
                        :up-to-now-amount="subtree.upToNowAmount"
                        :show-warning-if-exceeding-budget="false"/>

      <predicted-category-sections :actuals-title="titles.categorySections.actualsTitle"
                                   :recommended-title="titles.categorySections.recommendedTitle"
                                   :categories="subtree.categories"
                                   :initially-expanded="false"
                                   :show-recommended-title="true"
                                   :is-section-editable="true"
                                   :title="titles.categorySections.mainTitle"
                                   :expense-category="subtree.categoryName"
                                   v-on:edit-amount-clicked="emitOpenEditAmountPopup"
                                   v-on:section-clicked="sectionClicked(CASHFLOW_TYPE, $event)"
                                   v-on:category-sections-clicked="categorySectionsClicked(CASHFLOW_TYPE, $event)">
        <template v-slot:transactions="slotProps">
          <div class="transaction-list">
            <transaction-row class="transaction-details"
                             v-for="transaction in slotProps.transactions"
                             :transaction="transaction"
                             :can-edit-category="true"
                             :category-name="subtree.categoryName"
                             :category-id="subtree.categoryId"
                             v-bind:key="transaction.transactionId">
            </transaction-row>
          </div>
        </template>
      </predicted-category-sections>
    </div>
    <tracking-category-section-menu v-if="showSectionMenu"
                                    :category-name="subtree.categoryName"
                                    :envelope-id="subtree.envelopeId"
                                    :up-to-now-amount="subtree.upToNowAmount"
                                    :closeMenu="() => this.showSectionMenu = false"/>
  </div>
</template>

<script>
import Segment from '../../../../../../../../../Segment';
import PredictedCategorySections from '../../../generic-components/cashflow-types/cashflow-types-base/PredictedCategorySections.vue';
import ExpenseProgress from '../../../generic-components/cashflow-types/cashflow-types-base/ExpenseProgress.vue';
import TransactionRow from '../../../generic-components/cashflow-types/cashflow-types-base/TransactionRow.vue';
import CashflowAnalytics from '../../../generic-components/CashflowAnalytics.vue';
import EditAmountPopup from '../cashflow-edit/EditAmountPopup.vue';
import ModalBus from '../../../../../../../../../event-bus/modal-bus';
import TrackingCategorySectionMenu from '../cashflow-edit/edit-reccuring/TrackingCategorySectionMenu.vue';

export default {
  name: 'CashflowTypeTrackingCategory',
  mixins: [CashflowAnalytics],
  components: {
    TrackingCategorySectionMenu,
    TransactionRow,
    ExpenseProgress,
    PredictedCategorySections,
  },
  data() {
    return {
      showSectionMenu: false,
    };
  },
  props: [
    'subtree',
  ],
  computed: {
    CASHFLOW_TYPE() {
      return this.subtree.categoryName;
    },
    category() {
      return this.subtree.categories[0];
    },
    titles() {
      return {
        expenseProgress: {
          actualsLabel: 'יצא עד עכשיו',
          recommendedLabel: 'סה"כ צפוי לצאת',
        },
        categorySections: {
          actualsTitle: 'יצא',
          recommendedTitle: 'צפוי לצאת',
          mainTitle: `פירוט הוצאות ${this.subtree.categoryName}`,
        },
        cardTitle: `הוצאות ${this.subtree.categoryName}`,
      };
    },
  },
  methods: {
    emitOpenEditAmountPopup() {
      ModalBus.$emit('open', {
        component: EditAmountPopup,
        props: {
          expenseCategory: this.subtree.categoryName,
          category: this.category,
        },
      });
    },
    openSectionMenu() {
      Segment.trackUserInteraction('OpenSectionMenuClicked', {
        trackingCategory: this.subtree.categoryName,
      });
      this.showSectionMenu = true;
    },
  },
};
</script>

<style lang="scss">
  @import '../../../../../../../../../../node_modules/base-ui/src/scss/riseup-colors';
  @import '../../../../../../../../../scss/mixins';

  .cashflow-type-tracking-category {
    @include cashflow-card;
    position: relative;

    .card-wrapper {
      &.showing-edit-menu {
        opacity: 0.5;
      }

      .header {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .title {
          @include cashflow-card-title;
          white-space: nowrap;
        }

        .edit {
          height: 16px;
          cursor: pointer;
          margin-bottom: 10px;
        }
      }

      .cashflow-type-color {
        color: $riseup_light_blue;
      }

      .cashflow-type-background-color {
        background-color: $riseup_light_blue;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/responsive-pages/authenticated/navigation-pages/cashflow-app/cashflow-view/current-month/components/types/CashflowTypeTrackingCategory.vue